if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // === Detect if empty option is checked
      let optionEmptyIsChecked = false;
      const optionsEmpty = document.querySelectorAll('.product-form__option-input-empty');
      if (optionsEmpty.length > 0) {
        optionsEmpty.forEach(option => {

          if (option.checked) {
            const parent = option.closest('.product-form__input');
            if (parent !== null && parent !== undefined) {
              parent.classList.add('error');
            }
            optionEmptyIsChecked = true;
          }
          
        });
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true' || optionEmptyIsChecked) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      // Gift Card properties
      const giftCard = document.querySelector('[data-z-gift-card]');
      if (giftCard !== null && giftCard !== undefined) {

        config.headers['Content-Type'] = 'application/json';

        let giftCardProperties = {
          "_visuel": "",
          "_from": "",
          "_to": "",
          "_message": ""
        };
        
        // Visuel
        const giftCardVisuel = document.querySelector('[data-button-visuel-value].active');
        if (giftCardVisuel !== null && giftCardVisuel !== undefined) {
          const giftCardVisuelValue = giftCardVisuel.getAttribute('data-button-visuel-value');
          if (giftCardVisuelValue !== null && giftCardVisuelValue !== undefined && giftCardVisuelValue.length > 0) {
            giftCardProperties._visuel = giftCardVisuelValue;
          }
        }

        // From
        const giftCardFrom = document.getElementById('GiftCardForm-from');
        if (giftCardFrom !== null && giftCardFrom !== undefined) {
          const giftCardFromValue = giftCardFrom.value;
          if (giftCardFromValue !== null && giftCardFromValue !== undefined && giftCardFromValue.length > 0) {
            giftCardProperties._from = giftCardFromValue;
          }
        }

        // To
        const giftCardTo = document.getElementById('GiftCardForm-to');
        if (giftCardTo !== null && giftCardTo !== undefined) {
          const giftCardToValue = giftCardTo.value;
          if (giftCardToValue !== null && giftCardToValue !== undefined && giftCardToValue.length > 0) {
            giftCardProperties._to = giftCardToValue;
          }
        }

        // Message
        const giftCardMessage = document.getElementById('GiftCardForm-message');
        if (giftCardMessage !== null && giftCardMessage !== undefined) {
          const giftCardMessageValue = giftCardMessage.value;
          if (giftCardMessageValue !== null && giftCardMessageValue !== undefined && giftCardMessageValue.length > 0) {
            giftCardProperties._message = giftCardMessageValue;
          }
        }

        // === Process

        config.body = JSON.stringify({
          "id": formData.get('id'),
          "quantity": 1,
          "properties": giftCardProperties
        });

      } else {
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
